export const beautifyPhone = (number) => {
  return number.replace(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/g,"+$1($2)$3$4$5");
};
export const normalizedPhone = (value) => {
  if (!value) return false;
  let normalizedPhone = value.replace(/^[+]?([0-9]+)$/, '$1');
  normalizedPhone = normalizedPhone.replace(/^([87]{1,1})([0-9]+).*$/, '7$2');
  normalizedPhone = normalizedPhone.replace(/^([0-9]{11}).*$/, '$1');

  return normalizedPhone;
};

export const phoneNumberToShow = (string) => {
  const regex = /^sip:[+]?([\d\w]+)@[\d\w\S.]+$/;

  if (regex.test(string)) {
    return string.match(regex)[1];
  } else {
    return string ? normalizedPhone(string) : '';
  }
};

export const phoneNumberToCall = (string) => {
  const regex = /^sip:[+]?([\d]+)@[\d\w\S.]+$/;

  if (regex.test(string)) {
    return string.match(regex)[1];
  } else {
    return string;
  }
};

export const personName = (item, fullName = false, noPatronymic = false, positionName = false, returnEmpty = false) => {
  if (item) {
    const { firstName, lastName, patronymicName, username, position, employee } = item;
    let string = '';
    if (lastName) string = lastName;
    if (firstName) string += fullName ? ` ${firstName}` : lastName ? ` ${firstName[0]}.` : ` ${firstName}`;
    if (patronymicName && !noPatronymic) string += fullName ? ` ${patronymicName}` : lastName ?  ` ${patronymicName[0]}.` : ` ${patronymicName}`;
    if(position && positionName) string += ` (${position})`;
    /* new location field position */
    if(positionName && employee && employee.position) string += ` (${employee.position})`;


    if (!string && !username) return '';
    return string ? string : returnEmpty ? '' : username;
  }
  return '';
};

export const getIconByFileType = (link) => {
  const fileType = link.split('.').pop().toLocaleLowerCase();

  switch (fileType) {
    case 'jpg':
    case 'jpeg':
    case 'pjpeg':
    case 'gif':
    case 'png':
    case 'bmp':
      return 'image';
    case 'pdf':
      return 'picture_as_pdf';
    case 'doc':
    case 'docx':
    case 'xls':
    case 'xlsx':
    case 'txt':
    case 'csv':
    case 'ppt':
    case 'pptx':
      return 'insert_drive_file';
    case 'mp4':
    case 'webm':
    case 'ogg':
      return 'video_library';
    default:
      return 'description';
  }
};

export const colorByFileType = (link) => {
  const fileType = link.split('.').pop().toLocaleLowerCase();

  switch (fileType) {
    case 'jpg':
    case 'jpeg':
    case 'pjpeg':
    case 'gif':
    case 'png':
    case 'bmp':
      return '#5e8260';
    case 'mp4':
    case 'webm':
    case 'ogg':
      return '#986a66';
    default:
      return '#738686';
  }
};
